export default "__VITE_ASSET__DaqG$sm5__"